var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SISStudentMedical" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("ValidationObserver", {
            ref: "observer",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var handleSubmit = ref.handleSubmit
                  var invalid = ref.invalid
                  return [
                    _c(
                      "panel-basic",
                      {
                        staticClass: "rounded-top",
                        staticStyle: { "border-radius": "25px" },
                        attrs: {
                          title: _vm.title,
                          collapsable: true,
                          id: "panel",
                          "panel-class": "full-height",
                          helpText: _vm.helpText
                        }
                      },
                      [
                        _vm.showInsuranceFlag
                          ? _c(
                              "panel-basic",
                              {
                                staticClass: "rounded-top",
                                staticStyle: {
                                  "border-radius": "25px 25px 0 0"
                                },
                                attrs: {
                                  title: "Primary Insurance",
                                  collapsable: true,
                                  id: "primaryInsurance",
                                  "panel-class": "full-height"
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "insuranceNameOne"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.insuranceCompanyText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .INSURANCE_COMPANY,
                                                        expression:
                                                          "formData.SIS_MEDICAL.INSURANCE_COMPANY"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "insuranceNameOne",
                                                      "aria-label":
                                                        _vm.insuranceCompanyText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .INSURANCE_COMPANY
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "INSURANCE_COMPANY",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .INSURANCE_COMPANY
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .INSURANCE_COMPANY
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.insuranceCompanyText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "policyNumberOne"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.policyNumberText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .INSURANCE_POLICY_NO,
                                                        expression:
                                                          "formData.SIS_MEDICAL.INSURANCE_POLICY_NO"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "policyNumberOne",
                                                      "aria-label":
                                                        _vm.policyNumberText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .INSURANCE_POLICY_NO
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "INSURANCE_POLICY_NO",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .INSURANCE_POLICY_NO
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .INSURANCE_POLICY_NO
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.policyNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "idNumberOne"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.idNumberText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .HEALTH_CARD_NUMBER,
                                                        expression:
                                                          "formData.SIS_MEDICAL.HEALTH_CARD_NUMBER"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "idNumberOne",
                                                      "aria-label":
                                                        _vm.idNumberText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .HEALTH_CARD_NUMBER
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "HEALTH_CARD_NUMBER",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .HEALTH_CARD_NUMBER
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .HEALTH_CARD_NUMBER
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.idNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "groupNumberOne"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.groupNumberText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .GROUP_POLICY_NO,
                                                        expression:
                                                          "formData.SIS_MEDICAL.GROUP_POLICY_NO"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "groupNumberOne",
                                                      "aria-label":
                                                        _vm.groupNumberText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .GROUP_POLICY_NO
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "GROUP_POLICY_NO",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .GROUP_POLICY_NO
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .GROUP_POLICY_NO
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.groupNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showInsuranceFlag
                          ? _c(
                              "panel-basic",
                              {
                                staticClass: "rounded-top",
                                staticStyle: {
                                  "border-radius": "25px 25px 0 0"
                                },
                                attrs: {
                                  title: "Secondary Insurance",
                                  collapsable: true,
                                  id: "secondaryInsurance",
                                  "panel-class": "full-height"
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "insuranceNameTwo"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.insuranceCompanyText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .INSURANCE_COMPANY_2,
                                                        expression:
                                                          "formData.SIS_MEDICAL.INSURANCE_COMPANY_2"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "insuranceNameTwo",
                                                      "aria-label":
                                                        _vm.insuranceCompanyText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .INSURANCE_COMPANY_2
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "INSURANCE_COMPANY_2",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .INSURANCE_COMPANY_2
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .INSURANCE_COMPANY_2
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.groupNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "policyNumberTwo"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.policyNumberText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .INSURANCE_POLICY_NO_2,
                                                        expression:
                                                          "formData.SIS_MEDICAL.INSURANCE_POLICY_NO_2"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "policyNumberTwo",
                                                      "aria-label":
                                                        _vm.policyNumberText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .INSURANCE_POLICY_NO_2
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "INSURANCE_POLICY_NO_2",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .INSURANCE_POLICY_NO_2
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .INSURANCE_POLICY_NO_2
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.groupNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "idNumberTwo"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.idNumberText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .HEALTH_CARD_NUMBER_2,
                                                        expression:
                                                          "formData.SIS_MEDICAL.HEALTH_CARD_NUMBER_2"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "idNumberTwo",
                                                      "aria-label":
                                                        _vm.idNumberText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .HEALTH_CARD_NUMBER_2
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "HEALTH_CARD_NUMBER_2",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .HEALTH_CARD_NUMBER_2
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .HEALTH_CARD_NUMBER_2
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.idNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:30" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "groupNumberTwo"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.groupNumberText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .SIS_MEDICAL
                                                            .GROUP_POLICY_NO_2,
                                                        expression:
                                                          "formData.SIS_MEDICAL.GROUP_POLICY_NO_2"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      maxlength: "30",
                                                      name: "groupNumberTwo",
                                                      "aria-label":
                                                        _vm.groupNumberText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.SIS_MEDICAL
                                                          .GROUP_POLICY_NO_2
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .SIS_MEDICAL,
                                                          "GROUP_POLICY_NO_2",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .SIS_MEDICAL
                                                              .GROUP_POLICY_NO_2
                                                          ) > 30
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .SIS_MEDICAL
                                                                .GROUP_POLICY_NO_2
                                                            )
                                                          ) +
                                                          "/30\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.groupNumberText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showHospitalPreferenceFlag
                          ? _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-xs-12" },
                                [
                                  _c(
                                    "ValidationProvider",
                                    { ref: "provider" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "hospitalPreference" }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.hospitalPreferenceText
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.formData.SIS_MEDICAL
                                                  .HOSPITAL_PREFERENCE,
                                              expression:
                                                "formData.SIS_MEDICAL.HOSPITAL_PREFERENCE"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            name: "hospitalPreference",
                                            "aria-label":
                                              _vm.hospitalPreferenceText,
                                            disabled: _vm.isReadOnly
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.formData.SIS_MEDICAL,
                                                "HOSPITAL_PREFERENCE",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(_vm.hospitals, function(
                                          hospital,
                                          hospitalIndex
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: "hospital_" + hospitalIndex,
                                              domProps: {
                                                value: hospital.HOSPITAL_CODE
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    hospital.HOSPITAL_DESC
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.showPhysicianFlag
                          ? _c(
                              "panel-basic",
                              {
                                staticClass: "rounded-top",
                                staticStyle: {
                                  "border-radius": "25px 25px 0 0"
                                },
                                attrs: {
                                  title: "Primary Care Physician",
                                  collapsable: true,
                                  id: "primaryCarePhysician",
                                  "panel-class": "full-height"
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:50" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "physicianName"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.physicianNameText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData
                                                            .PHYSICIANS
                                                            .PHYSICIAN_NAME,
                                                        expression:
                                                          "formData.PHYSICIANS.PHYSICIAN_NAME"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name: "physicianName",
                                                      maxlength: "50",
                                                      "aria-label":
                                                        _vm.physicianNameText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.PHYSICIANS
                                                          .PHYSICIAN_NAME
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData
                                                            .PHYSICIANS,
                                                          "PHYSICIAN_NAME",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .PHYSICIANS
                                                              .PHYSICIAN_NAME
                                                          ) > 50
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .PHYSICIANS
                                                                .PHYSICIAN_NAME
                                                            )
                                                          ) +
                                                          "/50\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.physicianNameText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-9" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:15" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianPhoneNumber"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.physicianPhoneText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .PHYSICIANS
                                                                  .PHYSICIAN_PHONE_NO,
                                                              expression:
                                                                "formData.PHYSICIANS.PHYSICIAN_PHONE_NO"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianPhoneNumber",
                                                            maxlength: "15",
                                                            "aria-label":
                                                              _vm.physicianPhoneText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .PHYSICIANS
                                                                .PHYSICIAN_PHONE_NO
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .PHYSICIANS,
                                                                "PHYSICIAN_PHONE_NO",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .PHYSICIANS
                                                                    .PHYSICIAN_PHONE_NO
                                                                ) > 15
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .PHYSICIANS
                                                                      .PHYSICIAN_PHONE_NO
                                                                  )
                                                                ) +
                                                                "/15\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        _vm.physicianPhoneText
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-3" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:5" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianPhoneExtension"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.extText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .PHYSICIANS
                                                                  .PHYSICIAN_PHONE_EXT,
                                                              expression:
                                                                "formData.PHYSICIANS.PHYSICIAN_PHONE_EXT"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianPhoneExtension",
                                                            maxlength: "5",
                                                            "aria-label":
                                                              _vm.phoneNumberExtensionText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .PHYSICIANS
                                                                .PHYSICIAN_PHONE_EXT
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .PHYSICIANS,
                                                                "PHYSICIAN_PHONE_EXT",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .PHYSICIANS
                                                                    .PHYSICIAN_PHONE_EXT
                                                                ) > 5
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .PHYSICIANS
                                                                      .PHYSICIAN_PHONE_EXT
                                                                  )
                                                                ) +
                                                                "/5\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        "Physician Phone Ext"
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-9" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:15" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianFaxNumber"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.physicianFaxText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .PHYSICIANS
                                                                  .PHYSICIAN_FAX_NO,
                                                              expression:
                                                                "formData.PHYSICIANS.PHYSICIAN_FAX_NO"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianFaxNumber",
                                                            maxlength: "15",
                                                            "aria-label":
                                                              _vm.physicianFaxNumberText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .PHYSICIANS
                                                                .PHYSICIAN_FAX_NO
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .PHYSICIANS,
                                                                "PHYSICIAN_FAX_NO",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .PHYSICIANS
                                                                    .PHYSICIAN_FAX_NO
                                                                ) > 15
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .PHYSICIANS
                                                                      .PHYSICIAN_FAX_NO
                                                                  )
                                                                ) +
                                                                "/15\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        _vm.physicianFaxText
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-3" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:5" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianFaxExtension"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.extText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .PHYSICIANS
                                                                  .PHYSICIAN_FAX_EXT,
                                                              expression:
                                                                "formData.PHYSICIANS.PHYSICIAN_FAX_EXT"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianFaxExtension",
                                                            maxlength: "5",
                                                            "aria-label":
                                                              _vm.physicianFaxNumberExtensionText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .PHYSICIANS
                                                                .PHYSICIAN_FAX_EXT
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .PHYSICIANS,
                                                                "PHYSICIAN_FAX_EXT",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .PHYSICIANS
                                                                    .PHYSICIAN_FAX_EXT
                                                                ) > 5
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .PHYSICIANS
                                                                      .PHYSICIAN_FAX_EXT
                                                                  )
                                                                ) +
                                                                "/5\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        "Physician Fax Ext"
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row",
                                      staticStyle: { margin: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-12" },
                                        [
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "panel-basic",
                                            {
                                              staticClass: "rounded-top",
                                              staticStyle: {
                                                "border-radius": "25px 25px 0 0"
                                              },
                                              attrs: {
                                                title: "Address",
                                                collapsable: true,
                                                id: "physicianAddress"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-lg-6"
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:40"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "physicianAddressOne"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.addressOneText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS
                                                                            .PHYSICIAN_ADDRESS_1,
                                                                        expression:
                                                                          "formData.PHYSICIANS.PHYSICIAN_ADDRESS_1"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "physicianAddressOne",
                                                                      maxlength:
                                                                        "40",
                                                                      "aria-label":
                                                                        _vm.addressOneText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .PHYSICIANS
                                                                          .PHYSICIAN_ADDRESS_1
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS,
                                                                          "PHYSICIAN_ADDRESS_1",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .PHYSICIANS
                                                                              .PHYSICIAN_ADDRESS_1
                                                                          ) > 40
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .PHYSICIANS
                                                                                .PHYSICIAN_ADDRESS_1
                                                                            )
                                                                          ) +
                                                                          "/40\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  "Physician Address 1"
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-lg-6"
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:40"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "physicianAddressTwo"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.addressTwoText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS
                                                                            .PHYSICIAN_ADDRESS_2,
                                                                        expression:
                                                                          "formData.PHYSICIANS.PHYSICIAN_ADDRESS_2"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "physicianAddressTwo",
                                                                      maxlength:
                                                                        "40",
                                                                      "aria-label":
                                                                        _vm.addressTwoText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .PHYSICIANS
                                                                          .PHYSICIAN_ADDRESS_2
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS,
                                                                          "PHYSICIAN_ADDRESS_2",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .PHYSICIANS
                                                                              .PHYSICIAN_ADDRESS_2
                                                                          ) > 40
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .PHYSICIANS
                                                                                .PHYSICIAN_ADDRESS_2
                                                                            )
                                                                          ) +
                                                                          "/40\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  "Physician Address 2"
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-6" },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:40"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "physicianCity"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.cityText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS
                                                                            .PHYSICIAN_ADDRESS_CITY,
                                                                        expression:
                                                                          "formData.PHYSICIANS.PHYSICIAN_ADDRESS_CITY"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "physicianCity",
                                                                      maxlength:
                                                                        "40",
                                                                      "aria-label":
                                                                        _vm.cityText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .PHYSICIANS
                                                                          .PHYSICIAN_ADDRESS_CITY
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS,
                                                                          "PHYSICIAN_ADDRESS_CITY",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .PHYSICIANS
                                                                              .PHYSICIAN_ADDRESS_CITY
                                                                          ) > 40
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .PHYSICIANS
                                                                                .PHYSICIAN_ADDRESS_CITY
                                                                            )
                                                                          ) +
                                                                          "/40\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  "Physician City"
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-6" },
                                                    [
                                                      _c(
                                                        "ValidationProvider",
                                                        { ref: "provider" },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for:
                                                                  "physicianState"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.stateText
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.formData
                                                                      .PHYSICIANS
                                                                      .PHYSICIAN_ADDRESS_STATE,
                                                                  expression:
                                                                    "formData.PHYSICIANS.PHYSICIAN_ADDRESS_STATE"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                name:
                                                                  "physicianState",
                                                                "aria-label":
                                                                  _vm.stateText,
                                                                disabled:
                                                                  _vm.isReadOnly
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    _vm.formData
                                                                      .PHYSICIANS,
                                                                    "PHYSICIAN_ADDRESS_STATE",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.states,
                                                              function(
                                                                state,
                                                                stateIndex
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    key:
                                                                      "state_" +
                                                                      state.STATE_CODE +
                                                                      "_ " +
                                                                      stateIndex,
                                                                    domProps: {
                                                                      value:
                                                                        state.STATE_CODE
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          state.STATE_DESC
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "state_spacer"
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-6" },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:5"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "zipCode"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.zipCodeText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS
                                                                            .PHYSICIAN_ADDRESS_ZIP,
                                                                        expression:
                                                                          "formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "zipCode",
                                                                      maxlength:
                                                                        "5",
                                                                      "aria-label":
                                                                        _vm.zipCodeText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .PHYSICIANS
                                                                          .PHYSICIAN_ADDRESS_ZIP
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS,
                                                                          "PHYSICIAN_ADDRESS_ZIP",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .PHYSICIANS
                                                                              .PHYSICIAN_ADDRESS_ZIP
                                                                          ) > 5
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .PHYSICIANS
                                                                                .PHYSICIAN_ADDRESS_ZIP
                                                                            )
                                                                          ) +
                                                                          "/5\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  "Physician Zip Code"
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-5 col-md-2"
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:5"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "zipCodeExtension"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.extText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS
                                                                            .PHYSICIAN_ADDRESS_ZIP_EXT,
                                                                        expression:
                                                                          "formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP_EXT"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "zipCodeExtension",
                                                                      maxlength:
                                                                        "5",
                                                                      "aria-label":
                                                                        _vm.zipCodeExtensionText
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .PHYSICIANS
                                                                          .PHYSICIAN_ADDRESS_ZIP_EXT
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .PHYSICIANS,
                                                                          "PHYSICIAN_ADDRESS_ZIP_EXT",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .PHYSICIANS
                                                                              .PHYSICIAN_ADDRESS_ZIP_EXT
                                                                          ) > 5
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .PHYSICIANS
                                                                                .PHYSICIAN_ADDRESS_ZIP_EXT
                                                                            )
                                                                          ) +
                                                                          "/5\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  "Physician Zip Ext"
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showDentistFlag
                          ? _c(
                              "panel-basic",
                              {
                                staticClass: "rounded-top",
                                staticStyle: {
                                  "border-radius": "25px 25px 0 0"
                                },
                                attrs: {
                                  title: "Dentist",
                                  collapsable: true,
                                  id: "dentist",
                                  panelClass: "full-height"
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "provider",
                                        attrs: { rules: "max:50" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for:
                                                          "physicianDentistName"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.physicianNameText
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.formData.DENTISTS
                                                            .PHYSICIAN_NAME,
                                                        expression:
                                                          "formData.DENTISTS.PHYSICIAN_NAME"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name:
                                                        "physicianDentistName",
                                                      maxlength: "50",
                                                      "aria-label":
                                                        _vm.physicianNameText,
                                                      disabled: _vm.isReadOnly
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.formData.DENTISTS
                                                          .PHYSICIAN_NAME
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.formData.DENTISTS,
                                                          "PHYSICIAN_NAME",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      class: {
                                                        charactercount: true,
                                                        errorfont:
                                                          _vm.countCharacterLength(
                                                            _vm.formData
                                                              .DENTISTS
                                                              .PHYSICIAN_NAME
                                                          ) > 50
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.countCharacterLength(
                                                              _vm.formData
                                                                .DENTISTS
                                                                .PHYSICIAN_NAME
                                                            )
                                                          ) +
                                                          "/50\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  errors.length
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                errors[0].replace(
                                                                  "{field}",
                                                                  _vm.physicianNameText
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-9" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:15" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianDentistPhoneNumber"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.physicianPhoneText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .DENTISTS
                                                                  .PHYSICIAN_PHONE_NO,
                                                              expression:
                                                                "formData.DENTISTS.PHYSICIAN_PHONE_NO"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianDentistPhoneNumber",
                                                            maxlength: "15",
                                                            "aria-label":
                                                              _vm.physicianPhoneText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .DENTISTS
                                                                .PHYSICIAN_PHONE_NO
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .DENTISTS,
                                                                "PHYSICIAN_PHONE_NO",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .DENTISTS
                                                                    .PHYSICIAN_PHONE_NO
                                                                ) > 15
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .DENTISTS
                                                                      .PHYSICIAN_PHONE_NO
                                                                  )
                                                                ) +
                                                                "/15\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        _vm.physicianPhoneText
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-3" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:5" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianDentistPhoneExtension"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.extText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .DENTISTS
                                                                  .PHYSICIAN_PHONE_EXT,
                                                              expression:
                                                                "formData.DENTISTS.PHYSICIAN_PHONE_EXT"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianDentistPhoneExtension",
                                                            maxlength: "5",
                                                            "aria-label":
                                                              _vm.phoneNumberExtensionText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .DENTISTS
                                                                .PHYSICIAN_PHONE_EXT
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .DENTISTS,
                                                                "PHYSICIAN_PHONE_EXT",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .DENTISTS
                                                                    .PHYSICIAN_PHONE_EXT
                                                                ) > 5
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .DENTISTS
                                                                      .PHYSICIAN_PHONE_EXT
                                                                  )
                                                                ) +
                                                                "/5\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        _vm.phoneNumberExtensionText
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 col-md-4" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-9" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:15" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianDentistFaxNumber"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.physicianFaxText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .DENTISTS
                                                                  .PHYSICIAN_FAX_NO,
                                                              expression:
                                                                "formData.DENTISTS.PHYSICIAN_FAX_NO"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianDentistFaxNumber",
                                                            maxlength: "15",
                                                            "aria-label":
                                                              _vm.physicianFaxNumberText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .DENTISTS
                                                                .PHYSICIAN_FAX_NO
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .DENTISTS,
                                                                "PHYSICIAN_FAX_NO",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .DENTISTS
                                                                    .PHYSICIAN_FAX_NO
                                                                ) > 15
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .DENTISTS
                                                                      .PHYSICIAN_FAX_NO
                                                                  )
                                                                ) +
                                                                "/15\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        _vm.physicianFaxNumberText
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-xs-3" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "provider",
                                              attrs: { rules: "max:5" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for:
                                                                "physicianDentistFaxExtension"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.extText
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.formData
                                                                  .DENTISTS
                                                                  .PHYSICIAN_FAX_EXT,
                                                              expression:
                                                                "formData.DENTISTS.PHYSICIAN_FAX_EXT"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            name:
                                                              "physicianDentistFaxExtension",
                                                            maxlength: "5",
                                                            "aria-label":
                                                              _vm.physicianFaxNumberExtensionText,
                                                            disabled:
                                                              _vm.isReadOnly
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.formData
                                                                .DENTISTS
                                                                .PHYSICIAN_FAX_EXT
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.formData
                                                                  .DENTISTS,
                                                                "PHYSICIAN_FAX_EXT",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "small",
                                                          {
                                                            class: {
                                                              charactercount: true,
                                                              errorfont:
                                                                _vm.countCharacterLength(
                                                                  _vm.formData
                                                                    .DENTISTS
                                                                    .PHYSICIAN_FAX_EXT
                                                                ) > 5
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.countCharacterLength(
                                                                    _vm.formData
                                                                      .DENTISTS
                                                                      .PHYSICIAN_FAX_EXT
                                                                  )
                                                                ) +
                                                                "/5\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      errors[0].replace(
                                                                        "{field}",
                                                                        _vm.physicianFaxNumberExtensionText
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row",
                                      staticStyle: { margin: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-12" },
                                        [
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "panel-basic",
                                            {
                                              staticClass: "rounded-top",
                                              staticStyle: {
                                                "border-radius": "25px 25px 0 0"
                                              },
                                              attrs: {
                                                title: "Address",
                                                collapsable: true,
                                                id: "physicianDentistAddress"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-lg-6"
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:40"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "physicianDentistAddressOne"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.addressOneText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .DENTISTS
                                                                            .PHYSICIAN_ADDRESS_1,
                                                                        expression:
                                                                          "formData.DENTISTS.PHYSICIAN_ADDRESS_1"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "physicianDentistAddressOne",
                                                                      maxlength:
                                                                        "40",
                                                                      "aria-label":
                                                                        _vm.addressOneText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .DENTISTS
                                                                          .PHYSICIAN_ADDRESS_1
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .DENTISTS,
                                                                          "PHYSICIAN_ADDRESS_1",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .DENTISTS
                                                                              .PHYSICIAN_ADDRESS_1
                                                                          ) > 40
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .DENTISTS
                                                                                .PHYSICIAN_ADDRESS_1
                                                                            )
                                                                          ) +
                                                                          "/40\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  _vm.addressOneText
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-12 col-lg-6"
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:40"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "physicianDentistAddressTwo"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.addressTwoText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .DENTISTS
                                                                            .PHYSICIAN_ADDRESS_2,
                                                                        expression:
                                                                          "formData.DENTISTS.PHYSICIAN_ADDRESS_2"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "physicianDentistAddressTwo",
                                                                      maxlength:
                                                                        "40",
                                                                      "aria-label":
                                                                        _vm.addressTwoText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .DENTISTS
                                                                          .PHYSICIAN_ADDRESS_2
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .DENTISTS,
                                                                          "PHYSICIAN_ADDRESS_2",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .DENTISTS
                                                                              .PHYSICIAN_ADDRESS_2
                                                                          ) > 40
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .DENTISTS
                                                                                .PHYSICIAN_ADDRESS_2
                                                                            )
                                                                          ) +
                                                                          "/40\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  _vm.addressTwoText
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-6" },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "provider",
                                                        attrs: {
                                                          rules: "max:40"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "physicianDentistCity"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.cityText
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .formData
                                                                            .DENTISTS
                                                                            .PHYSICIAN_ADDRESS_CITY,
                                                                        expression:
                                                                          "formData.DENTISTS.PHYSICIAN_ADDRESS_CITY"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "form-control",
                                                                    attrs: {
                                                                      type:
                                                                        "text",
                                                                      name:
                                                                        "physicianDentistCity",
                                                                      maxlength:
                                                                        "40",
                                                                      "aria-label":
                                                                        _vm.cityText,
                                                                      disabled:
                                                                        _vm.isReadOnly
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .DENTISTS
                                                                          .PHYSICIAN_ADDRESS_CITY
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .formData
                                                                            .DENTISTS,
                                                                          "PHYSICIAN_ADDRESS_CITY",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      class: {
                                                                        charactercount: true,
                                                                        errorfont:
                                                                          _vm.countCharacterLength(
                                                                            _vm
                                                                              .formData
                                                                              .DENTISTS
                                                                              .PHYSICIAN_ADDRESS_CITY
                                                                          ) > 40
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.countCharacterLength(
                                                                              _vm
                                                                                .formData
                                                                                .DENTISTS
                                                                                .PHYSICIAN_ADDRESS_CITY
                                                                            )
                                                                          ) +
                                                                          "/40\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  errors.length
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                errors[0].replace(
                                                                                  "{field}",
                                                                                  _vm.cityText
                                                                                )
                                                                              ) +
                                                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-6" },
                                                    [
                                                      _c(
                                                        "ValidationProvider",
                                                        { ref: "provider" },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for:
                                                                  "physicianDentistState"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.stateText
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.formData
                                                                      .DENTISTS
                                                                      .PHYSICIAN_ADDRESS_STATE,
                                                                  expression:
                                                                    "formData.DENTISTS.PHYSICIAN_ADDRESS_STATE"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                name:
                                                                  "physicianDentistState",
                                                                "aria-label":
                                                                  _vm.stateText,
                                                                disabled:
                                                                  _vm.isReadOnly
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    _vm.formData
                                                                      .DENTISTS,
                                                                    "PHYSICIAN_ADDRESS_STATE",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.states,
                                                              function(
                                                                state,
                                                                stateIndex
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    key:
                                                                      "state_" +
                                                                      state.STATE_CODE +
                                                                      "_ " +
                                                                      stateIndex,
                                                                    domProps: {
                                                                      value:
                                                                        state.STATE_CODE
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          state.STATE_DESC
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "state_spacer"
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-6" },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-8"
                                                            },
                                                            [
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  ref:
                                                                    "provider",
                                                                  attrs: {
                                                                    rules:
                                                                      "max:5"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "default",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "label",
                                                                              {
                                                                                attrs: {
                                                                                  for:
                                                                                    "zipCodeDentist"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      _vm.zipCodeText
                                                                                    ) +
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .formData
                                                                                        .DENTISTS
                                                                                        .PHYSICIAN_ADDRESS_ZIP,
                                                                                    expression:
                                                                                      "formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "form-control",
                                                                                attrs: {
                                                                                  type:
                                                                                    "text",
                                                                                  name:
                                                                                    "zipCodeDentist",
                                                                                  maxlength:
                                                                                    "5",
                                                                                  "aria-label":
                                                                                    _vm.zipCodeText,
                                                                                  disabled:
                                                                                    _vm.isReadOnly
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    _vm
                                                                                      .formData
                                                                                      .DENTISTS
                                                                                      .PHYSICIAN_ADDRESS_ZIP
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .formData
                                                                                        .DENTISTS,
                                                                                      "PHYSICIAN_ADDRESS_ZIP",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                class: {
                                                                                  charactercount: true,
                                                                                  errorfont:
                                                                                    _vm.countCharacterLength(
                                                                                      _vm
                                                                                        .formData
                                                                                        .DENTISTS
                                                                                        .PHYSICIAN_ADDRESS_ZIP
                                                                                    ) >
                                                                                    5
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      _vm.countCharacterLength(
                                                                                        _vm
                                                                                          .formData
                                                                                          .DENTISTS
                                                                                          .PHYSICIAN_ADDRESS_ZIP
                                                                                      )
                                                                                    ) +
                                                                                    "/5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            errors.length
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-danger"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                        _vm._s(
                                                                                          errors[0].replace(
                                                                                            "{field}",
                                                                                            _vm.zipCodeText
                                                                                          )
                                                                                        ) +
                                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-1"
                                                            },
                                                            [
                                                              _c("label", {
                                                                staticStyle: {
                                                                  "min-height":
                                                                    "19px"
                                                                },
                                                                attrs: {
                                                                  for: "hyphen"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "form-control",
                                                                  staticStyle: {
                                                                    border:
                                                                      "none",
                                                                    "box-shadow":
                                                                      "none",
                                                                    "-webkit-box-shadow":
                                                                      "none"
                                                                  },
                                                                  attrs: {
                                                                    name:
                                                                      "hyphen"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-3"
                                                            },
                                                            [
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  ref:
                                                                    "provider",
                                                                  attrs: {
                                                                    rules:
                                                                      "max:5"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "default",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "label",
                                                                              {
                                                                                staticStyle: {
                                                                                  "min-height":
                                                                                    "19px"
                                                                                },
                                                                                attrs: {
                                                                                  for:
                                                                                    "zipCodeExtensionDentist"
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .formData
                                                                                        .DENTISTS
                                                                                        .PHYSICIAN_ADDRESS_ZIP_EXT,
                                                                                    expression:
                                                                                      "formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP_EXT"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "form-control",
                                                                                attrs: {
                                                                                  type:
                                                                                    "text",
                                                                                  name:
                                                                                    "zipCodeExtensionDentist",
                                                                                  maxlength:
                                                                                    "5",
                                                                                  "aria-label":
                                                                                    _vm.zipCodeExtensionText,
                                                                                  disabled:
                                                                                    _vm.isReadOnly
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    _vm
                                                                                      .formData
                                                                                      .DENTISTS
                                                                                      .PHYSICIAN_ADDRESS_ZIP_EXT
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .formData
                                                                                        .DENTISTS,
                                                                                      "PHYSICIAN_ADDRESS_ZIP_EXT",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                class: {
                                                                                  charactercount: true,
                                                                                  errorfont:
                                                                                    _vm.countCharacterLength(
                                                                                      _vm
                                                                                        .formData
                                                                                        .DENTISTS
                                                                                        .PHYSICIAN_ADDRESS_ZIP_EXT
                                                                                    ) >
                                                                                    5
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                    _vm._s(
                                                                                      _vm.countCharacterLength(
                                                                                        _vm
                                                                                          .formData
                                                                                          .DENTISTS
                                                                                          .PHYSICIAN_ADDRESS_ZIP_EXT
                                                                                      )
                                                                                    ) +
                                                                                    "/5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            errors.length
                                                                              ? _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-danger"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                        _vm._s(
                                                                                          errors[0].replace(
                                                                                            "{field}",
                                                                                            _vm.zipCodeExtensionText
                                                                                          )
                                                                                        ) +
                                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }